import React from "react";
import {SxProps, Theme} from "@mui/material/styles";
import {Box, Button, Card, Stack, Typography} from "@mui/material";
import {alpha} from "@mui/material/styles";
import InstallMobileRoundedIcon from "@mui/icons-material/InstallMobileRounded";
import IosShareRoundedIcon from "@mui/icons-material/IosShareRounded";
import {COLOR_AZUL_OSCURO} from "../../../components/layout/colors";
import {isIos, useInstallPrompt} from "../../../components/utils/install_prompt";
import {panelSx} from "./timeclock_util";

/**
 * «Instala la app» donde se ficha (pantalla de fichar y portada del empleado), solo si aún no está
 * instalada (#13811). Donde el
 * navegador lo permite (Chrome, Edge, Android) el botón abre su diálogo; en iPhone no hay tal
 * diálogo y se explica el paso de Compartir. Abierta ya como app, no sale.
 */
export const InstallCard = ({sx}: { sx?: SxProps<Theme> }) => {
	const {canInstall, installed, install} = useInstallPrompt();
	const ios = isIos();

	if (installed || (!canInstall && !ios)) {
		return null;
	}

	return (
		<Card elevation={0} sx={{...panelSx, ...(sx as object)}}>
			<Stack direction={{xs: "column", sm: "row"}} spacing={2} alignItems={{xs: "stretch", sm: "center"}}>
				<Stack direction="row" spacing={2} alignItems="center" sx={{flexGrow: 1, minWidth: 0}}>
					<Box sx={{
						width: 44, height: 44, borderRadius: 2, flexShrink: 0, display: "grid", placeItems: "center",
						bgcolor: alpha(COLOR_AZUL_OSCURO, 0.1), color: COLOR_AZUL_OSCURO,
					}}>
						<InstallMobileRoundedIcon/>
					</Box>
					<Box sx={{minWidth: 0}}>
						<Typography variant="subtitle1" fontWeight={700}>Ficha desde una app en tu móvil</Typography>
						<Typography variant="body2" color="text.secondary">
							{ios
								? <>Pulsa <IosShareRoundedIcon sx={{fontSize: 16, verticalAlign: "-3px"}}/> Compartir y
									luego «Añadir a pantalla de inicio». Se abre directamente aquí y te avisa si se te
									olvida fichar.</>
								: "Se abre directamente en esta pantalla y te avisa si se te olvida fichar."}
						</Typography>
					</Box>
				</Stack>
				{canInstall && (
					<Button variant="contained" disableElevation onClick={install}
							startIcon={<InstallMobileRoundedIcon/>}
							sx={{textTransform: "none", fontWeight: 600, borderRadius: 2, flexShrink: 0}}>
						Instalar la app
					</Button>
				)}
			</Stack>
		</Card>
	);
};
